'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Toggle = require('./components/Toggle.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Toggle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drawer/lib/components/toggle/index.js
// module id = 1070
// module chunks = 1